import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import Confirm from 'views/confirm/confirm'
import { connect } from 'react-redux'
import bindActionsToDispatch from 'helpers/bindActionsToDispatch'

import googleDriveActions from 'redux/actions/googleDriveActions'
import { localize } from 'helpers/translator'
import { autorizeUser } from 'helpers/googleDrive'
import formatError from 'redux/sagas/helpers/error_formatter'

class GoogleSlidesPopUpBlocked extends PureComponent {

	tryAgain = () => {
		autorizeUser().then(() => {
			this.props.actions.googleAuthorizeUserSuccess()
		}).catch(error => {
			const serverError = formatError(error)
			this.props.actions.googleAuthorizeUserCancel(serverError)
		})
	}

	cancel = () => {
		this.props.actions.googleAuthorizeUserCancel(this.props.error)
	}

	render() {
		return (
			<Confirm
				btOne={localize('global_cancel')}
				btTwo={localize('global_tryAgain')}
				alertMessage={localize('googleSlides_popUpBlocked')}
				actionButtonType={0}
				actionOne={this.cancel}
				actionTwo={this.tryAgain}
				closeAction={this.cancel}
			/>
		)
	}
}

GoogleSlidesPopUpBlocked.propTypes = {
	actions: PropTypes.shape({
		googleAuthorizeUserSuccess: PropTypes.func.isRequired,
		googleAuthorizeUserCancel: PropTypes.func.isRequired,
	}).isRequired,
	error: PropTypes.object,
}

GoogleSlidesPopUpBlocked.defaultProps = {
	error: {},
}

function mapDispatchToProps(dispatch) {
	return bindActionsToDispatch({
		googleAuthorizeUserSuccess: googleDriveActions.googleAuthorizeUserSuccess,
		googleAuthorizeUserCancel: googleDriveActions.googleAuthorizeUserCancel,
	}, dispatch)
}

export default connect(null, mapDispatchToProps)(GoogleSlidesPopUpBlocked)

export { GoogleSlidesPopUpBlocked }
